import { Vendor_UNASSIGNED, Vendor_UNASSIGNED_SUCCESS, Vendor_UNASSIGNED_ERROR, Vendor_UNASSIGNED_EMPTY } from '../../../../actionType';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const VendorUnAssigned = (state = initialState, action) => {
  switch (action.type) {
    case Vendor_UNASSIGNED:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case Vendor_UNASSIGNED_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case Vendor_UNASSIGNED_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case Vendor_UNASSIGNED_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default VendorUnAssigned;
